<script setup lang="ts">
import { BookOpen, Leaf } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import GameIcon from '@/components/GameIcon.vue'
import { GAME_ICONS } from '@/ui/game-icons'

defineProps<{ source: 'mxdc' | 'fengji' }>()
const { t } = useI18n()
const XIAOCES_LOGO = 'https://mxdc.dvg.cn/public/assets/images/brand/logo_lit.png'
</script>

<template>
  <span class="rank-source-brand" :class="`rank-source-brand--${source}`">
    <GameIcon :src="source === 'mxdc' ? XIAOCES_LOGO : GAME_ICONS.mapleLeaf" dimension="1.125rem" image-dimension="1.125rem" eager>
      <BookOpen v-if="source === 'mxdc'" /><Leaf v-else />
    </GameIcon>
    <span>{{ t(`rank.sourceName.${source}`) }}</span>
  </span>
</template>

<style scoped>
.rank-source-brand { display: inline-flex; align-items: center; gap: 0.375rem; vertical-align: middle; white-space: nowrap; line-height: 1.5; }
.rank-source-brand--mxdc :deep(.game-art img) { image-rendering: auto; }
.rank-source-brand--fengji :deep(.game-art img) { image-rendering: pixelated; }
</style>
